import { Pipe, PipeTransform } from '@angular/core';
/*
 * Camel case string but make eSports exception
 * Takes a string as a value.
 * Usage:
 *    value | ngxCamelCaseEsports
 *
 * Example:
 *     value.name = esports
 *     {{ value.name | ngxCamelCaseEsports  }}
 *     formats to: eSports
*/
@Pipe({
    name: 'ngxCamelCaseEsports'
})
export class TransformCamelCaseEsportsPipe implements PipeTransform {
    transform(str: string): string {
        if (str === null) return '';
        if (str.toLowerCase() === 'esports') return 'eSports';
        if (str.toLowerCase() === 'esport') return 'eSport';

        return str.replace(/\w\S*/g, txt => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });

    }
}
